import { SubmissionFileMetadata } from '@common/types';
import { BoxItem } from 'box-ui-elements/es';
import { getFileIsHidden, getFileWithSyncMetadata } from 'broker/components/FilesExplorer/utils';

export function getRelevantBoxItems(boxItems: BoxItem[], submissionFileMetadata?: SubmissionFileMetadata[]) {
  return (
    boxItems
      .filter((item) => item.type === 'file')
      // Filter out hidden files
      .filter((item) => !getFileIsHidden(item))
      .map((item) => getFileWithSyncMetadata(item, submissionFileMetadata))
  );
}
